export const PATH_INDEX = '/';
export const MAIN_INDEX = '/';

export const LINK_PATH_HOME = 'https://bishares.finance/';
export const LINK_PATH_ABOUT = 'https://bishares.finance/about-us';
export const LINK_PATH_FUNDS = 'https://app.bishares.finance/#/';

export const API_APE_SWAP_GRAPH = 'https://graph.apeswap.finance/subgraphs/name/ape-swap/apeswap-subgraph';
